/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFileLiteInfo
 */
export interface CaseFileLiteInfo {
    /**
     * 
     * @type {string}
     * @memberof CaseFileLiteInfo
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseFileLiteInfo
     */
    parties?: Array<string> | null;
}

export function CaseFileLiteInfoFromJSON(json: any): CaseFileLiteInfo {
    return CaseFileLiteInfoFromJSONTyped(json, false);
}

export function CaseFileLiteInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileLiteInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'parties': !exists(json, 'parties') ? undefined : json['parties'],
    };
}

export function CaseFileLiteInfoToJSON(value?: CaseFileLiteInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'parties': value.parties,
    };
}


